import React from 'react';
import Svg,{Circle,Ellipse,Polygon} from 'react-native-svg';

// Fixed deterministic vector fallback: no continuous worker, renderer or network.
export default function DiagramEffects({effects,tones}) {
  return <Svg pointerEvents="none" width="100%" height="100%" viewBox="0 0 1000 600" style={{position:'absolute',left:0,top:0}}>
    {effects.flatMap(e=>{
      const [x,y]=e.point,[ex,ey]=e.end,color=tones[e.tone||'accent'],r=e.radius;
      if(e.type==='glow')return [3,2,1].map(n=><Circle key={`${e.key}-${n}`} cx={x} cy={y} r={r*n*.6} fill={color} opacity={e.opacity*.12}/>);
      if(e.type==='flame')return [1,.65,.3].map((n,i)=>{const dx=(ex-x)*n,dy=(ey-y)*n,len=Math.hypot(dx,dy)||1,nx=-dy/len*r*.25*n,ny=dx/len*r*.25*n;
        return <Polygon key={`${e.key}-${i}`} points={`${x+nx},${y+ny} ${x+dx},${y+dy} ${x-nx},${y-ny}`} fill={i===2?'#FFE9A8':color} opacity={e.opacity*(.4+i*.2)}/>;});
      return Array.from({length:8},(_,i)=>{const t=(i/8+e.phase)%1,px=x+(ex-x)*t,py=y+(ey-y)*t;
        return e.type==='water'?<Ellipse key={`${e.key}-${i}`} cx={px} cy={py} rx={r*(.3+t*.3)} ry={r*.08} stroke={color} fill="none" opacity={e.opacity*(1-t)*.55}/>
          :<Circle key={`${e.key}-${i}`} cx={px} cy={py} r={e.type==='steam'?r*(.06+t*.12):Math.max(2,r*.05)} fill={color} opacity={e.opacity*(1-t)*(e.type==='steam'?.2:.8)}/>;
      });
    })}
  </Svg>;
}
